export enum BackgroundTasksTaskStateEnum {
  READY = 'ready',
  LAUNCHING = 'launching',
  FINISHED = 'finished',
  ERROR = 'error'
}
